/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { AbstractCommand } from '../AbstractCommand';
import { ModelUtils } from '../util/ModelUtils';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { NodeCompat } from '../../compat/NodeCompat';
import { Document } from '../../core/models/Document';
import { OasDocument } from '../../openapi/models/OasDocument';
import { OasParameter } from '../../openapi/models/OasParameter';
import { OasPathItem } from '../../openapi/models/OasPathItem';

/**
 * A command used to rename a path item, along with all references to it.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class RenamePathItemCommand extends AbstractCommand {
    public _oldPath : string;

    public _newPath : string;

    public _alsoRenameSubpaths : boolean;

    public constructor(oldPath? : any, newPath? : any, alsoRenameSubpaths? : any) {
        if(((typeof oldPath === 'string') || oldPath === null) && ((typeof newPath === 'string') || newPath === null) && ((typeof alsoRenameSubpaths === 'boolean') || alsoRenameSubpaths === null)) {
            let __args = arguments;
            super();
            if(this._oldPath===undefined) this._oldPath = null;
            if(this._newPath===undefined) this._newPath = null;
            if(this._alsoRenameSubpaths===undefined) this._alsoRenameSubpaths = false;
            if(this._oldPath===undefined) this._oldPath = null;
            if(this._newPath===undefined) this._newPath = null;
            if(this._alsoRenameSubpaths===undefined) this._alsoRenameSubpaths = false;
            (() => {
                this._oldPath = oldPath;
                this._newPath = newPath;
                this._alsoRenameSubpaths = alsoRenameSubpaths;
            })();
        } else if(oldPath === undefined && newPath === undefined && alsoRenameSubpaths === undefined) {
            let __args = arguments;
            super();
            if(this._oldPath===undefined) this._oldPath = null;
            if(this._newPath===undefined) this._newPath = null;
            if(this._alsoRenameSubpaths===undefined) this._alsoRenameSubpaths = false;
            if(this._oldPath===undefined) this._oldPath = null;
            if(this._newPath===undefined) this._newPath = null;
            if(this._alsoRenameSubpaths===undefined) this._alsoRenameSubpaths = false;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[RenamePathItemCommand] Executing.");
        this._doPathRename(document, this._oldPath, this._newPath, this._alsoRenameSubpaths);
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[RenamePathItemCommand] Reverting.");
        this._doPathRename(document, this._newPath, this._oldPath, this._alsoRenameSubpaths);
    }

    /**
     * Does the work of renaming a path from one name to another.
     * @param {Document} document
     * @param {string} from
     * @param {string} to
     * @param {boolean} alsoRenameSubpaths
     * @private
     */
    /*private*/ _doPathRename(document : Document, from : string, to : string, alsoRenameSubpaths : boolean) {
        let pathsToRename : Array<string[]> = <any>([]);
        /* add */(pathsToRename.push([from, to])>0);
        let odoc : OasDocument = <OasDocument>document;
        if(this._alsoRenameSubpaths && ModelUtils.isDefined(odoc.paths)) {
            let pathItemNames : Array<string> = odoc.paths.getPathItemNames();
            for(let index207=0; index207 < pathItemNames.length; index207++) {
                let pathName = pathItemNames[index207];
                {
                    if(pathName.indexOf(from) === 0 && !NodeCompat.equals(pathName, from)) {
                        /* add */(pathsToRename.push([pathName, to + pathName.substring(from.length)])>0);
                    }
                }
            }
        }
        pathsToRename.forEach(((odoc) => {
            return (p2r) => {
                this._renamePath(odoc, p2r[0], p2r[1]);
            }
        })(odoc));
    }

    /**
     * Does the work of renaming a path.
     * @param {string} from
     * @param {string} to
     * @param {OasDocument} document
     * @private
     */
    /*private*/ _renamePath(document : OasDocument, from : string, to : string) {
        let fromPathParamNames : Array<string> = ModelUtils.detectPathParamNames(from);
        let toPathParamNames : Array<string> = ModelUtils.detectPathParamNames(to);
        if(/* size */(<number>fromPathParamNames.length) !== /* size */(<number>toPathParamNames.length)) {
            LoggerCompat.warn("Renaming a path with %o parameters to a new value that has %o parameters!", /* size */(<number>fromPathParamNames.length), /* size */(<number>toPathParamNames.length));
        }
        let path : OasPathItem = document.paths.removePathItem(from);
        if(NodeCompat.isNullOrUndefined(path)) {
            return;
        }
        path.rename(to);
        document.paths.addPathItem(to, path);
        for(let idx : number = 0; idx < /* size */(<number>fromPathParamNames.length); idx++) {{
            let fromParamName : string = /* get */fromPathParamNames[idx];
            let toParamName : string = null;
            if(idx < /* size */(<number>toPathParamNames.length)) {
                toParamName = /* get */toPathParamNames[idx];
            }
            if(ModelUtils.isDefined(toParamName)) {
                this._renamePathParameter(path, fromParamName, toParamName);
            } else {
                this._removePathParameter(path, fromParamName);
            }
        };}
        if(/* size */(<number>toPathParamNames.length) > /* size */(<number>fromPathParamNames.length)) {
            for(let idx : number = /* size */(<number>fromPathParamNames.length); idx < /* size */(<number>toPathParamNames.length); idx++) {{
                let paramName : string = /* get */toPathParamNames[idx];
                let parameter : OasParameter = path.createParameter();
                parameter.name = paramName;
                parameter.in = "path";
                parameter.required = true;
                path.addParameter(parameter);
            };}
        }
    }

    /**
     * Rename a path parameter.
     * @param {OasPathItem} path
     * @param {string} fromParamName
     * @param {string} toParamName
     * @private
     */
    /*private*/ _renamePathParameter(path : OasPathItem, fromParamName : string, toParamName : string) {
        if(!NodeCompat.equals(fromParamName, toParamName) && ModelUtils.isDefined(path.parameters)) {
            path.parameters.forEach((param) => {
                if(NodeCompat.equals(param.in, "path") && NodeCompat.equals(param.name, fromParamName)) {
                    param.name = toParamName;
                }
            });
        }
    }

    /**
     * Remove a path parameter.
     * @param {OasPathItem} path
     * @param {string} fromParamName
     * @private
     */
    /*private*/ _removePathParameter(path : OasPathItem, fromParamName : string) {
        if(this.isNullOrUndefined(path.parameters)) {
            return;
        }
        let paramIdx : number = -1;
        for(let idx : number = 0; idx < /* size */(<number>path.parameters.length); idx++) {{
            let param : OasParameter = /* get */path.parameters[idx];
            if(NodeCompat.equals(param.name, fromParamName) && NodeCompat.equals(param.in, "path")) {
                paramIdx = idx;
            }
        };}
        if(paramIdx !== -1) {
            /* remove */path.parameters.splice(paramIdx, 1)[0];
        }
    }
}
RenamePathItemCommand["__class"] = "io.apicurio.datamodels.cmd.commands.RenamePathItemCommand";
RenamePathItemCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




